import { Route } from 'react-router-dom';
import { TargetShell } from '../identity/TargetShell';
import { DesignTenantsPage } from './pages/Tenants';
import { DesignTenantDetailPage } from './pages/TenantDetail';

/** The NYCE Design group's routes; every page runs inside the environment shell (only environments with a DesignUrl). */
export function designRoutes(allowed: (path: string) => boolean) {
  if (!allowed('/design/tenants')) return [];
  return [
    <Route
      key="/design/tenants"
      path="/design/tenants"
      element={
        <TargetShell service="design">
          <DesignTenantsPage />
        </TargetShell>
      }
    />,
    <Route
      key="/design/tenants/:id"
      path="/design/tenants/:id"
      element={
        <TargetShell service="design">
          <DesignTenantDetailPage />
        </TargetShell>
      }
    />,
  ];
}
